import {Component} from '@angular/core';
import {AppMainComponent} from './app.main.component';

// Aviso de facturas vencidas; lo comparten los layouts de todas las plantillas.
@Component({
    selector: 'app-aviso-deuda',
    template: `
        <div *ngIf="appMain?.muestraAvisoDeuda">
            <p-message [severity]="appMain?.severidadAvisoDeuda">
                <div class="flex align-items-center">
                    <img src="assets/resources/images/late-payment.png" width="32" />
                    <div class="grid grid-nogutter ml-2">
                        <div class="col-12 text-bold">{{appMain?.tituloAvisoDeuda}}</div>
                        <div class="col-12">
                            <p>
                                Tiene {{appMain?.miFacturacion?.facturasVencidas}} factura(s) vencida(s) por
                                <b>{{appMain?.deudaVencida | montoDinero: appMain?.miFacturacion?.moneda}}</b>,
                                con hasta {{appMain?.diasDeAtrasoMaximo}} días de atraso.

                                <ng-container *ngIf="appMain?.miFacturacion?.nivelMora === 'CORTE_INMINENTE'">
                                    Su cuenta de {{appMain?.nameCompany}} puede ser suspendida en cualquier momento.
                                    Regularice el pago hoy mismo.
                                </ng-container>
                                <ng-container *ngIf="appMain?.miFacturacion?.nivelMora === 'URGENTE'">
                                    De no regularizarlo, el servicio se suspenderá en
                                    {{appMain?.miFacturacion?.diasParaCorte}} día(s).
                                </ng-container>
                                <ng-container *ngIf="appMain?.miFacturacion?.nivelMora === 'AVISO'">
                                    Cuenta con {{appMain?.miFacturacion?.diasParaCorte}} día(s) más antes de que
                                    el servicio se vea afectado.
                                </ng-container>

                                Puede ver el detalle en <a routerLink="/facturacion">Facturación</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </p-message>
        </div>
    `,
    standalone: false
})
export class AppAvisoDeudaComponent {
    constructor(public appMain: AppMainComponent) {}
}
